// extracted by mini-css-extract-plugin
export default {"row":"FormDataPermission_row__F-LTb","col":"FormDataPermission_col__-fAgq","checked":"FormDataPermission_checked__V3DkE"};